import { BILLING_TYPE_LABELS } from 'domain/shared/newProject';
import { asciiTextValidation, digitSymbolValidation } from 'framework/form';

const updateBudgetLayoutValidation = {
  sowId: {
    type: 'string',
    required: true,
    ...digitSymbolValidation,
  },
  projectName: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  billingType: {
    type: 'string',
    required: true,
    regex: {
      value: new RegExp(Object.keys(BILLING_TYPE_LABELS).join('|'), 'ig'),
      message: 'Legacy billing type is not supported.',
    },
  },
  fte: {
    type: 'number',
    required: true,
  },
  hours: {
    type: 'number',
    required: true,
  },
  amount: {
    type: 'string',
    required: true,
  },
  currency: {
    type: 'string',
    required: true,
  },
  relatedDocuments: {
    type: 'array',
    required: false,
  },
};

export default updateBudgetLayoutValidation;
